/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import * as yup from 'yup';
import { Form as FormUi, Button, Label, Modal, Table, Icon, Grid, Input, Loader } from 'semantic-ui-react';
import { Field as Fieldmik, FieldArray, Formik, ErrorMessage } from 'formik';
import Axios from 'axios';
import cogoToast from 'cogo-toast';
import APP_CONSTANT from '../../config/constants';

import { MyInput } from '../formikInput/input';
import CustomDropdown from '../formikInput/customDropdown';
import PSLineItemDropdown from '../dropdowns/psLineItemDropdown';

import OptionsUPLBillApproval from './optionsUPLBillApproval';
import { values } from 'lodash';
import { defaultBillValues, FEATURES, UPLDefaultBillValues } from "../../config/features";
import { DATE_FORMATS, LOCAL_STORAGE, REQUIRED_MESSAGES } from '../../config/const';
import { fields, titles } from './bill.constants';
import moment from 'moment/moment';

const BillApprovalModal = ({ getApproveBillData, selectedRows, approveBillsSelected, handleCloseBillApproval, approveButtonLoading, ...props }) => {

  const [disabledButton, setDisabledButton] = useState(false)
  const [billDetails, setBillDetails] = useState([])
  const [productCodes, setProductCodes] = useState([])
  const [glCodeOptions, setGlCodeOptions] = useState([])
  const [costCenterOptions, setCostCenterOptions] = useState([])
  const [glCodeLoading, setGlCodeLoading] = useState(true)
  const [fieldsEdited, setFieldsEdited] = useState({})

  

  let billDetailsArray = [];
  useEffect(() => {
    // getBranches();
    selectedRows && selectedRows.map((o, i) => {
      let temp = {}
      temp.billReferenceNo = o.refNo
      temp.billNo = o.billNo
      temp.billDate = o.billDate
      temp.billAmount = o.billAmount
      temp.billReceiptDate = o.billReceiptDate
      temp.vendorName = o.vendorName
      temp.vendorCode = o.vendorCode
      temp.branchCode = o.branchCode
      temp.costCenter = o.branchCode
      temp.branchName = o.branchName
      temp.approvalStatus = "Approved"
      temp.id = o.billId
      temp.billPO = o.billPO
      if (!defaultBillValues) {
        temp.penaltyList = [{
          psCode: '',
          penaltyAmt: '',
        }]
      }

      if (defaultBillValues) {
        temp.companyCode = "";
        temp.businessPlace = "";
        temp.sectionCode = "";
        temp.taxCode = "";
        temp.glCode = "";
        temp.costCenter = "";
        temp.text = "";
        temp.flag = "";
        temp.headerText = "";
        temp.profitCenter = "";
        temp.thirdPartyPoReferenceNumber = FEATURES.isThirdPartyPoReferenceNumberNeededInBillApproval ? o.remarks : "";
      }
      if (UPLDefaultBillValues) {
        //temp.costCenter = "SC0201";
        temp.profitCenter = "SC0201";
        temp.businessPlace = "ST06";
        temp.sectionCode = "IN01";
        temp.glCode = "401101";
        temp.taxCode = "RA";
        temp.text = o.remarks;
        temp.headerText = o.remarks;
        temp.companyCode = '1000';
      }

      billDetailsArray[i] = temp
    });
    setBillDetails(billDetailsArray)
  }, [])

  // useEffect(async () => {
  //   let productCodes = []

  //   for (let i = 0; i < billDetails.length; i++) {
  //     let data = await fetchProductDetails(billDetails[i])
  //     productCodes.push({ billNo: billDetails[i].billNo, productCodes: [...new Set(data)] })
  //   }

  //   setProductCodes(productCodes)
  // }, [billDetails])

  // useEffect(async () => {
  //   let glCodeOptions = []

  //   for (let i = 0; i < productCodes.length; i++) {
  //     let data = await getGLCodes(productCodes[i].productCodes)

  //     data = data.reduce((uniqueCodes, item) => {
  //       let isDuplicate = uniqueCodes.some((code) => {
  //         return code.value == item.value ? true : false
  //       })
  //       return isDuplicate ? uniqueCodes : [...uniqueCodes, item]
  //     }, [])

  //     glCodeOptions.push(data)
  //     setGlCodeLoading(false)
  //   }

  //   setGlCodeOptions(glCodeOptions)
  // }, [productCodes])

  // const getGLCodes = async (productCodes) => {
  //   let glCodes = []
  //   productCodes = productCodes.join(',')

  //   let { data } = await Axios.get(
  //     `${APP_CONSTANT.BASE_URL}masters/psLineItemGLCodeMapping/?customerNo=${LOCAL_STORAGE.customerNo}&productCodes=${productCodes}&userId=${LOCAL_STORAGE.userId}`,
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: LOCAL_STORAGE.userToken,
  //         "Access-Control-Allow-Origin": "*",
  //       },
  //     }
  //   );

  //   if (data.status == 200) {
  //     glCodes = data.resultSet.map((item) => {
  //       return {
  //         key: item.psLineItemGLCodeMappingId,
  //         value: item.psLineItemGLCode,
  //         text: item.psLineItemGLCode,
  //       };
  //     })

  //     return glCodes
  //   }
  //   return []
  // }

  // const fetchProductDetails = async (billDetails) => {
  //   let billPoMapping = billDetails?.billPO

  //   const { data } = await Axios.post(
  //     `${APP_CONSTANT.BASE_URL}purchase/purchaseorder/getPOPagination?page=1`,
  //     {
  //       api_token: LOCAL_STORAGE.userToken,
  //       customerNo: LOCAL_STORAGE.customerNo,
  //       userId: LOCAL_STORAGE.userId,
  //       billId: billDetails.id,
  //     },
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: LOCAL_STORAGE.userToken,
  //         "Access-Control-Allow-Origin": "*",
  //       },
  //     }
  //   );
  //   // selecting POs mapped to selected bill
  //   data.data = data.data?.filter((item) => {
  //     return billPoMapping?.some((billPo) => {
  //       return billPo.poId == item.poId
  //     })
  //   })

  //   return data?.data?.reduce((result, item) => {
  //     let skuDetails = item.skuDetails ? JSON.parse(item.skuDetails) : []
  //     let skuCodes = skuDetails.map((sku) => sku.skuCode)
  //     // result = [...result, ...(item?.po_details?.map((_item) => _item.productId))]
  //     result = [...result, ...skuCodes]
  //     return result
  //   }, [])
  // }

  // const getBranches = async () => {
  //   let { data } = await Axios.post(
  //     `${APP_CONSTANT.BASE_URL}masters/branch/`,
  //     {
  //       customerNumber: LOCAL_STORAGE.customerNo,
  //       userId: LOCAL_STORAGE.userId,
  //     },
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: LOCAL_STORAGE.userToken,
  //         "Access-Control-Allow-Origin": "*",
  //       },
  //     }
  //   );
  //   if (data.status === 200) {
  //     let branchOptions = data.resultSet.map((item) => {
  //       return {
  //         key: item.branchId,
  //         value: item.branchCode,
  //         text: `${item.branchCode} - ${item.branchName}`,
  //         name: item.branchName,
  //       };
  //     });

  //     setCostCenterOptions(branchOptions);
  //   }
  // }

  const initialValues = {
    billDetails: billDetailsArray
  };

  const onSubmit = (values) => {

    let approvalStatusData = []
    setDisabledButton(true)
    let errorObj = false

    values.billDetails.map((o, i) => {

      let temp = {}
      temp.billReferenceNo = o.billReferenceNo
      temp.billNo = o.billNo
      temp.billDate = o.billDate
      temp.billAmount = o.billAmount
      temp.billReceiptDate = o.billReceiptDate
      temp.approvalStatus = "Approved"
      temp.vendorCode = o.vendorCode
      temp.vendorName = o.vendorName
      if(!o.vendorCode || !o.vendorName){
        cogoToast.error(`Bill Reference Number ${o.billReferenceNo} not mapped to vendor`)
        errorObj = true
        return
      }

      if (UPLDefaultBillValues) {
        temp.branchCode = o?.branchCode
        temp.branchName = o?.branchName
        temp.companyCode = o.companyCode
        temp.businessPlace = o.businessPlace
        temp.sectionCode = o.sectionCode
        temp.taxCode = o.taxCode
        temp.glCode = o.glCode
        // if (o.flag != 'MIRO') {
        //   temp.costCenter = o.costCenter
        // }
        temp.text = o.text
        temp.flag = o.flag
        temp.headerText = o.headerText
        temp.profitCenter = o.profitCenter
        temp.thirdPartyPoReferenceNumber = o.thirdPartyPoReferenceNumber

        if(!o?.branchCode || !o?.branchName){
          cogoToast.error(`Bill Reference Number ${o.billReferenceNo} not mapped to branch`)
          errorObj = true
          return
        }

        /* temp.companyCode = document.getElementById('companyCode').value;
        temp.businessPlace = document.getElementById('businessPlace').value;
        temp.sectionCode = document.getElementById('sectionCode').value;
        temp.taxCode = document.getElementById('taxCode').value;
        temp.glCode = document.getElementById('glCode').value;
        temp.costCenter = document.getElementById('costCenter').value;
        temp.text = document.getElementById('text').value;
        temp.flag = document.getElementById('flag').value;
        temp.headerText = document.getElementById('headerText').value;
        temp.profitCenter = document.getElementById('profitCenter').value;
        temp.thirdPartyPoReferenceNumber = document.getElementById('companyCode').thirdPartyPoReferenceNumber; */
      }

      if (!UPLDefaultBillValues) {
        // let costCenter = costCenterOptions.find((item) => {
        //   return item.value == o.costCenter;
        // })
        let psLine = []
        o.penaltyList.map((penalty, penaltyIndex) => {

          if (penalty.psCode.length > 0 && penalty.penaltyAmt > 0) {
            let tempPenalty = {}
            tempPenalty.psCode = penalty.psCode
            tempPenalty.penaltyAmt = penalty.penaltyAmt
            psLine[penaltyIndex] = tempPenalty
          }
        })
        temp.penaltyList = psLine
        // temp.costCenter = o.costCenter
        temp.branchCode = o?.branchCode
        temp.branchName = o?.branchName
        // temp.branchId = costCenter?.key || null
        // temp.GLCode = o.glCode || glCodeOptions[i] ? glCodeOptions[i][0]?.value : null
      }
      approvalStatusData[i] = temp

    })

    if(errorObj){
      setDisabledButton(false)
      return
    }

    //approveBillsSelected(approvalStatusData)
    const approvalData = {
      customerNo: LOCAL_STORAGE.customerNo,
      userId: LOCAL_STORAGE.userId,
      billDetails: approvalStatusData
    }
    Axios.patch(`${APP_CONSTANT.BASE_URL}purchase/bill/updateBillStatus`, approvalData, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": LOCAL_STORAGE.userToken,
        "Access-Control-Allow-Origin": "*"
      }
    })
      .then((response) => {
        if (response.status === 0 && response.data.data.failedCount > 0) {
          cogoToast.error(<div>
            <p>{response.data.data.errorMsg}</p>
            <p>Success Count: {response.data.data.successCount}</p>
            <p>Failed Count: {response.data.data.failedCount}</p>
          </div>, { position: 'top-right' }).then(() => {
            window.location.reload()
          })

        } else {
          cogoToast.success(<div>
            <p>{response.data.message}</p>
            <p>Success Count: {response.data.data.successCount}</p>
            <p>Failed Count: {response.data.data.failedCount}</p>
          </div>, { position: 'top-right' }).then(() => {
            window.location.reload()
          })
        }
        setDisabledButton(false)
      })
      .catch((err) => {
        if (err?.response?.data?.message)
          cogoToast.error(err.response.data.message, { position: 'top-right' })
        setDisabledButton(false)
      })
      ;

  };

  const validateSchema = yup.object({
    billDetails: yup.array().of(
      yup.object().shape({
        flag: yup.string().required('Transaction is required'),
        profitCenter: yup.string().optional().nullable()
          .when("flag", (flag) =>
            flag == "MIRO" ? yup.string().optional().required() : yup.string().optional().nullable()
          ),
        costCenter: FEATURES.profitCentreForNonMIRO ? yup.string().optional().nullable() :
        yup.string().optional().nullable()
          .when("flag", (flag) =>
            flag != "MIRO" ? yup.string().optional().required() : yup.string().optional().nullable()
          ),
        //costCenter: yup.string().required("Cost center is Required"),
        thirdPartyPoReferenceNumber: yup.string().required(),
        companyCode: yup.string().required(),
        businessPlace: yup.string().required(),
        sectionCode: yup.string().required(),
        taxCode: yup.string().required(),
        text: yup.string().required().max(50,REQUIRED_MESSAGES.MAX_LENGTH(50)),
        headerText: yup.string().required().max(25,REQUIRED_MESSAGES.MAX_LENGTH(25)),
        glCode: yup.string().optional().nullable()
          .when("flag", (flag) =>
            flag != "MIRO" ? yup.string().optional().required() : yup.string().optional().nullable()
          ),
        penaltyList: yup.array().of(
          yup.object().shape({
            psCode: yup.mixed(),
            penaltyAmt: yup.number().positive().when(['psCode','billAmount'], (psCode, billAmount, schema) => {
              return psCode && psCode.length > 0 ? schema.required("Penalty Amount is Required").min(1, "Penalty Amount should be more than 0").max(billAmount,'Penalty Amount should not be grater than Bill Amount') : schema.min(1)
            })
          })
        )
      })
    ),
  })

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={defaultBillValues ? validateSchema : yup.object({})}
        onSubmit={onSubmit}
      >
        {({ touched, errors, handleSubmit, isSubmitting }) => (
          <>
          {console.log({errors})}
            <FieldArray
              name={'billDetails'}
            >
              {({ push, remove, form }) => {
                const { inititalValues, values, setFieldValue } = form
                const { billDetails } = values
                return (
                  <>

                    <Modal.Content className="content-adjust">
                      {(localStorage.getItem('customerNo') == 1165 || localStorage.getItem('customerNo') == 1166) ?
                        <>
                          {
                            billDetails.map((bill, billIndex) => {
                              return (
                                <>
                                  {billIndex > 0 ? <hr className="hr-break" /> : null}
                                  <Grid className="margin-adjust">
                                    <Grid.Row columns={3} className="header-adjust">
                                      <Grid.Column>
                                        <FormUi.Group className="display-flex-spacebtwn">
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600 margin-right">Bill Reference No</label>
                                          </FormUi.Field>
                                          <FormUi.Field>
                                            <label className="labelName mt-2">{bill.billReferenceNo}</label>
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                      <Grid.Column>
                                        <FormUi.Group className="display-flex-spacebtwn">
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600 margin-right">Branch Code</label>
                                          </FormUi.Field>
                                          <FormUi.Field>
                                            <label className="labelName mt-2">{bill.branchCode}</label>
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                      <Grid.Column>
                                        <FormUi.Group className="display-flex-spacebtwn">
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600 margin-right">Bill Date</label>
                                          </FormUi.Field>
                                          <FormUi.Field>
                                            <label className="labelName mt-2">{bill.billDate}</label>
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                    </Grid.Row>

                                    <hr className="hr-break" />

                                    <Grid.Row columns={4} className="padding-bottom-0">
                                      <Grid.Column>
                                        <FormUi.Group >
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600 required-form-element">Transaction</label>
                                          </FormUi.Field>
                                          <FormUi.Field className="input-adjust">
                                            <Fieldmik id="flag" name={`billDetails[${billIndex}].flag`} upward={false} component={CustomDropdown} filteredOptions={[{ text: 'MIRO', value: 'MIRO' }, { text: 'FB60', value: 'FB60' }]} type="text" placeholder="Transaction" />
                                            {touched?.billDetails?.length > 0 && touched?.billDetails[0] && touched?.billDetails[billIndex]?.flag && errors?.billDetails?.length > 0 && errors?.billDetails[billIndex]?.flag ? (
                                              <strong className="w3-text-red w3-tiny font-weight-bold">
                                                Transaction is required
                                              </strong>
                                            ) : (
                                              ""
                                            )}
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                      <>
                                        {values.billDetails[billIndex].flag == "MIRO" ?
                                          <Grid.Column>
                                            <FormUi.Group >
                                              <FormUi.Field>
                                                <label className="labelName mt-2 p-bold-600 required-form-element">Profit Center</label>
                                              </FormUi.Field>
                                              <FormUi.Field className="input-adjust">
                                                <Fieldmik id="profitCenter" value={values?.billDetails[billIndex]?.flag ? bill?.profitCenter : null} name={`billDetails[${billIndex}].profitCenter`} component={MyInput} type="text" maxLength="10" placeholder="Profit Center" />
                                                {touched?.billDetails?.length > 0 && touched?.billDetails[0] && touched?.billDetails[billIndex]?.profitCenter && errors?.billDetails?.length > 0 && errors?.billDetails[billIndex]?.profitCenter ? (
                                                  <strong className="w3-text-red w3-tiny font-weight-bold">
                                                    Profit Center is required
                                                  </strong>
                                                ) : (
                                                  ""
                                                )}
                                              </FormUi.Field>
                                            </FormUi.Group>

                                          </Grid.Column>
                                          : null}
                                        {values.billDetails[billIndex].flag != "MIRO" ?
                                          <Grid.Column>
                                            <FormUi.Group >
                                              <FormUi.Field>
                                                <label className="labelName mt-2 p-bold-600 required-form-element">{FEATURES.profitCentreForNonMIRO ? "Profit Center" :"Cost Center"}</label>
                                              </FormUi.Field>
                                              <FormUi.Field className="input-adjust">
                                                <Fieldmik id="costCenter" value={values?.billDetails[billIndex]?.flag ? (FEATURES.profitCentreForNonMIRO ? bill?.profitCenter : bill?.costCenter) : null} name={FEATURES.profitCentreForNonMIRO ? `billDetails[${billIndex}].profitCenter` :`billDetails[${billIndex}].costCenter`} upward={true} component={CustomDropdown} filteredOptions={OptionsUPLBillApproval('COST_CENTER').COST_CENTER} type="text" placeholder={FEATURES.profitCentreForNonMIRO ? "Profit Center" :"Cost Center"} />
                                                {touched?.billDetails?.length > 0 && touched?.billDetails[0] && touched?.billDetails[billIndex]?.costCenter && errors?.billDetails?.length > 0 && errors?.billDetails[billIndex]?.costCenter ? (
                                                  <strong className="w3-text-red w3-tiny font-weight-bold">
                                                    Cost Center is required
                                                  </strong>
                                                ) : (
                                                  ""
                                                )}
                                              </FormUi.Field>
                                            </FormUi.Group>
                                          </Grid.Column>
                                          : null}
                                        {
                                          values.billDetails[billIndex].flag ?
                                            <Grid.Column width={localStorage.getItem('customerNo') == 1166 ? 8 : ""}>
                                              <FormUi.Group >
                                                <FormUi.Field>
                                                  <label className="labelName mt-2 p-bold-600 required-form-element">{values.billDetails[billIndex].flag == 'MIRO' ? 'Purchase Order Number' : 'Sales Order Number'}</label>
                                                </FormUi.Field>
                                                <FormUi.Field className="input-adjust">
                                                  <Fieldmik className="input-adjust-input" id="thirdPartyPoReferenceNumber" name={`billDetails[${billIndex}].thirdPartyPoReferenceNumber`} type="text" component={MyInput} onChange={(e)=>{
                                                    setFieldValue(`billDetails[${billIndex}].thirdPartyPoReferenceNumber`, e.target.value)
                                                    !fieldsEdited.text && setFieldValue(`billDetails[${billIndex}].text`, e.target.value)
                                                    !fieldsEdited.headerText && setFieldValue(`billDetails[${billIndex}].headerText`, e.target.value)
                                                  }} placeholder={values?.billDetails.length > 0 && values?.billDetails[billIndex]?.flag && values.billDetails[billIndex].flag == 'MIRO' ? "Purchase Order Number" : "Sales Order Number"} />
                                                  {touched?.billDetails?.length > 0 && touched?.billDetails[0] && errors?.billDetails?.length > 0 && touched?.billDetails[billIndex]?.thirdPartyPoReferenceNumber && errors?.billDetails[billIndex]?.thirdPartyPoReferenceNumber ? (
                                                    <strong className="w3-text-red w3-tiny font-weight-bold">
                                                      {values.billDetails[billIndex].flag == 'MIRO' ? 'Purchase Order Number is required' : 'Sales Order Number is required'}
                                                    </strong>
                                                  ) : (
                                                    ""
                                                  )}
                                                </FormUi.Field>
                                              </FormUi.Group>
                                            </Grid.Column>
                                            : null
                                        }
                                      </>

                                    </Grid.Row>
                                    <Grid.Row columns={4} >
                                      <Grid.Column>
                                        <FormUi.Group >
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600 required-form-element">Company Code</label>
                                          </FormUi.Field>
                                          <FormUi.Field className="input-adjust">
                                            <Fieldmik id="companyCode" value={values.billDetails[billIndex].flag ? bill.companyCode : null} name={`billDetails[${billIndex}].companyCode`} component={CustomDropdown} filteredOptions={OptionsUPLBillApproval('COMPANY_CODE').COMPANY_CODE} type="text" placeholder="Company Code" />
                                            {touched?.billDetails?.length > 0 && touched?.billDetails[0] && errors?.billDetails?.length > 0 && touched?.billDetails[billIndex]?.companyCode && errors?.billDetails[billIndex]?.companyCode ? (
                                              <strong className="w3-text-red w3-tiny font-weight-bold">
                                                Company Code is required
                                              </strong>
                                            ) : (
                                              ""
                                            )}
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                      <Grid.Column>
                                        <FormUi.Group >
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600 required-form-element">Business Place</label>
                                          </FormUi.Field>
                                          <FormUi.Field className="input-adjust">
                                            <Fieldmik id="businessPlace" value={values.billDetails[billIndex].flag ? bill.businessPlace : null} name={`billDetails[${billIndex}].businessPlace`} component={CustomDropdown} filteredOptions={OptionsUPLBillApproval('BUSINESS_PLACE').BUSINESS_PLACE} type="text" placeholder="Business Place" />
                                            {touched?.billDetails?.length > 0 && touched?.billDetails[0] && errors?.billDetails?.length > 0 && touched?.billDetails[billIndex]?.businessPlace && errors?.billDetails[billIndex]?.businessPlace ? (
                                              <strong className="w3-text-red w3-tiny font-weight-bold">
                                                Business Place is required
                                              </strong>
                                            ) : (
                                              ""
                                            )}
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                      <Grid.Column>
                                        <FormUi.Group >
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600 required-form-element">Section Code</label>
                                          </FormUi.Field>
                                          <FormUi.Field className="input-adjust">
                                            <Fieldmik disabled id="sectionCode" value={values.billDetails[billIndex].flag ? bill.sectionCode : null} name={`billDetails[${billIndex}].sectionCode`} component={CustomDropdown} 
                                            filteredOptions={OptionsUPLBillApproval('SECTION_CODE').SECTION_CODE}
                                             type="text" placeholder="Section Code" />
                                            {touched?.billDetails?.length > 0 && touched?.billDetails[0] && errors?.billDetails?.length > 0 && touched?.billDetails[billIndex]?.sectionCode && errors?.billDetails[billIndex]?.sectionCode ? (
                                              <strong className="w3-text-red w3-tiny font-weight-bold">
                                                Section Code is required
                                              </strong>
                                            ) : (
                                              ""
                                            )}
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                      <Grid.Column>
                                        <FormUi.Group >
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600 required-form-element">Tax Code</label>
                                          </FormUi.Field>
                                          <FormUi.Field className="input-adjust">
                                            <Fieldmik id="taxCode" value={values.billDetails[billIndex].flag ? bill.taxCode : null} name={`billDetails[${billIndex}].taxCode`} component={CustomDropdown} filteredOptions={OptionsUPLBillApproval('TAX_CODE').TAX_CODE} type="text" placeholder="Tax Code" />
                                            {touched?.billDetails?.length > 0 && touched?.billDetails[0] && errors?.billDetails?.length > 0 && touched?.billDetails[billIndex]?.taxCode && errors?.billDetails[billIndex]?.taxCode ? (
                                              <strong className="w3-text-red w3-tiny font-weight-bold">
                                                Tax Code is required
                                              </strong>
                                            ) : (
                                              ""
                                            )}
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                      <Grid.Column>
                                        <FormUi.Group >
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600">GL Code</label>
                                            {values.billDetails[billIndex].flag == "MIRO" ?
                                              <></>
                                              :
                                              <span className="required-form-element"></span>
                                            }
                                          </FormUi.Field>
                                          <FormUi.Field className="input-adjust">
                                            <Fieldmik id="glCode" value={values.billDetails[billIndex].flag ? bill.glCode : null} name={`billDetails[${billIndex}].glCode`} upward={true} component={CustomDropdown} filteredOptions={OptionsUPLBillApproval('GL_CODE').GL_CODE} type="text" placeholder="GL Code" />
                                            {touched?.billDetails?.length > 0 && touched?.billDetails[0] && errors?.billDetails?.length > 0 && touched?.billDetails[billIndex]?.glCode && errors?.billDetails[billIndex]?.glCode ? (
                                              <strong className="w3-text-red w3-tiny font-weight-bold">
                                                GL Code is required
                                              </strong>
                                            ) : (
                                              ""
                                            )}
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>

                                      <Grid.Column>
                                        <FormUi.Group >
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600 required-form-element">Text</label>
                                          </FormUi.Field>
                                          <FormUi.Field className="input-adjust">
                                            <Fieldmik id="text" value={values.billDetails[billIndex].flag ? bill.text : null} name={`billDetails[${billIndex}].text`} component={MyInput} type="text" maxLength="50" placeholder="Text" onChange={(e)=>{
                                                  setFieldValue(`billDetails[${billIndex}].text`, e.target.value)
                                                  setFieldsEdited({...fieldsEdited, text:true})
                                                  }} />
                                            {touched?.billDetails?.length > 0 && touched?.billDetails[0] && errors?.billDetails?.length > 0 && touched?.billDetails[billIndex]?.text && errors?.billDetails[billIndex]?.text ? (
                                              <strong className="w3-text-red w3-tiny font-weight-bold">
                                                Text is required
                                              </strong>
                                            ) : (
                                              ""
                                            )}
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                      <Grid.Column>
                                        <FormUi.Group >
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600 required-form-element">Header Text</label>
                                          </FormUi.Field>
                                          <FormUi.Field className="input-adjust">
                                            <Fieldmik id="headerText" value={values.billDetails[billIndex].flag ? bill.headerText : null} name={`billDetails[${billIndex}].headerText`} component={MyInput} type="text" maxLength="25" placeholder="Header Text" onChange={(e)=>{
                                                  setFieldValue(`billDetails[${billIndex}].headerText`, e.target.value)
                                                  setFieldsEdited({...fieldsEdited, headerText:true})
                                                  }} />
                                            {touched?.billDetails?.length > 0 && touched?.billDetails[0] && errors?.billDetails?.length > 0 && touched?.billDetails[billIndex]?.headerText && errors?.billDetails[billIndex]?.headerText ? (
                                              <strong className="w3-text-red w3-tiny font-weight-bold">
                                                Text is required
                                              </strong>
                                            ) : (
                                              ""
                                            )}
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                    </Grid.Row>
                                  </Grid>


                                  {/*                                   <Table verticalAlign stackable>
                                    <Table.Header>
                                      <Table.Row>
                                        <Table.HeaderCell ><label className="labelName p-bold-600">Bill Number</label></Table.HeaderCell>
                                        <Table.Row>
                                          <Table.HeaderCell colSpan={5} width={5}><label className="labelName p-bold-600">Expense Particular</label></Table.HeaderCell>
                                          <Table.HeaderCell colSpan={5} width={5}><label className="labelName p-bold-600" style={{ marginLeft: '70px' }}>Penalty Amount</label></Table.HeaderCell>
                                          <Table.HeaderCell colSpan={4} width={4}></Table.HeaderCell>
                                        </Table.Row>

                                      </Table.Row>
                                    </Table.Header>
                                    <Table.Body>



                                      <>
                                        {console.log("Values Values", form)}
                                        <Table.Row>
                                          <Table.Cell>
                                            <FormUi.Field>
                                              <Fieldmik name="billReferenceNo" component={MyInput} placeholder="Code" value={bill.billReferenceNo} />
                                              {touched.billReferenceNo && errors.billReferenceNo ? <Label size="mini" prompt pointing>{errors.billReferenceNo}</Label> : ''}
                                            </FormUi.Field>
                                          </Table.Cell>

                                          <FieldArray
                                            name={`billDetails[${billIndex}].penaltyList`}
                                          >
                                            {({ push, remove, form }) => {

                                              const { initialValues, values, setFieldValue } = form
                                              const { penaltyList } = values.billDetails[billIndex]


                                              return (
                                                <>
                                                  {penaltyList.map((penalty, penaltyIndex) => (
                                                    <>
                                                      <Table.Row key={`{bill}+ ${penaltyIndex}`}>
                                                        <Table.Cell width={4}>
                                                          <FormUi.Field>
                                                            <Fieldmik name={`billDetails[${billIndex}].penaltyList[${penaltyIndex}].psCode`} component={PSLineItemDropdown} placeholder="Enter Expense Code" />
                                                            <ErrorMessage name={`billDetails[${billIndex}].penaltyList[${penaltyIndex}].psCode`}>{msg => <Label size="mini" basic color="red" pointing>{msg}</Label>}</ErrorMessage>
                                                          </FormUi.Field>
                                                        </Table.Cell>

                                                        <Table.Cell width={2}>
                                                          <FormUi.Field>
                                                            <Fieldmik name={`billDetails[${billIndex}].penaltyList[${penaltyIndex}].penaltyAmt`} style={{ width: '160px' }} component={MyInput} type="number" placeholder="Enter Amount" />
                                                            <ErrorMessage name={`billDetails[${billIndex}].penaltyList[${penaltyIndex}].penaltyAmt`}>{msg => <Label size="mini" basic color="red" pointing>{msg}</Label>}</ErrorMessage>
                                                          </FormUi.Field>
                                                        </Table.Cell>

                                                        <Table.Cell width={2}>
                                                          {penaltyIndex > 0 ?
                                                            <Button onClick={() => remove(penaltyIndex)} type="button" basic size="mini" icon>
                                                              <Icon className="overhere" color="red" name="trash" />
                                                            </Button>
                                                            :
                                                            ''}
                                                        </Table.Cell>
                                                      </Table.Row>

                                                    </>
                                                  ))}

                                                  <Table.Cell>
                                                    <Button type="button" onClick={() => push({ psCode: '', penaltyAmt: '' })} size="mini" basic color="blue">
                                                      + Add
                                                    </Button>
                                                  </Table.Cell>

                                                </>
                                              )
                                            }}
                                          </FieldArray>
                                        </Table.Row>
                                      </>

                                    </Table.Body>

                                  </Table> */}

                                </>
                              )
                            })
                          }
                        </>
                        :
                        <>
                          {/* {
                            billDetails.map((bill, billIndex) => {
                              return (
                                <>
                                  {billIndex > 0 ? <hr className="hr-break" /> : null}

                                  <Grid className="margin-adjust">
                                    <Grid.Row columns={4} className="header-adjust">
                                      <Grid.Column>
                                        <FormUi.Group className="display-flex-spacebtwn">
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600 margin-right">{titles.billReferenceNumber || "Bill Reference No"}</label>
                                          </FormUi.Field>
                                          <FormUi.Field>
                                            <label className="labelName mt-2">{bill.billReferenceNo}</label>
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                      <Grid.Column>
                                        <FormUi.Group className="display-flex-spacebtwn">
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600 margin-right">{titles.branchCode || "Branch Code"}</label>
                                          </FormUi.Field>
                                          <FormUi.Field>
                                            <label className="labelName mt-2">{bill.branchCode}</label>
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                      <Grid.Column>
                                        <FormUi.Group className="display-flex-spacebtwn">
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600 margin-right">{titles.branchName || "Branch Name"}</label>
                                          </FormUi.Field>
                                          <FormUi.Field>
                                            <label className="labelName mt-2">{bill.branchName}</label>
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                      <Grid.Column>
                                        <FormUi.Group className="display-flex-spacebtwn">
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600 margin-right">{titles.billDate || "Bill Date"}</label>
                                          </FormUi.Field>
                                          <FormUi.Field>
                                            <label className="labelName mt-2">{moment(bill.billDate).format(DATE_FORMATS.DD_MM_YYYY)}</label>
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                    </Grid.Row>

                                    <Grid.Row columns={2} >
                                      <Grid.Column>
                                        <FormUi.Group >
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600">{fields.costCenter.label || "Cost Center"}</label>
                                          </FormUi.Field>
                                          <FormUi.Field className="input-adjust">
                                            <Fieldmik id="costCenter" value={bill.costCenter} name={`billDetails[${billIndex}].costCenter`} upward={true} component={CustomDropdown} filteredOptions={costCenterOptions} type="text" placeholder="Cost Center" />
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                      <Grid.Column>
                                        <FormUi.Group >
                                          <FormUi.Field>
                                            <label className="labelName mt-2 p-bold-600">{fields.glCode.label || "GL Code"}</label>
                                          </FormUi.Field>
                                          <FormUi.Field className="input-adjust">
                                            <Fieldmik id="glCode" value={bill.glCode || glCodeOptions[billIndex] && glCodeOptions[billIndex][0]?.value || ''} name={`billDetails[${billIndex}].glCode`} upward={true} component={CustomDropdown} filteredOptions={glCodeOptions[billIndex]} loading={glCodeLoading} placeholder="GL Code" />
                                          </FormUi.Field>
                                        </FormUi.Group>
                                      </Grid.Column>
                                    </Grid.Row>
                                  </Grid>
                                </>
                              )
                            })}
                          <hr className="hr-break" /> */}
                          <label className="labelName mt-2 p-bold-600">{titles.expences || "Expences"}</label>
                          <Table verticalAlign stackable>
                            <Table.Header>
                              <Table.Row>
                                <Table.HeaderCell ><label className="labelName p-bold-600">{titles.billNumber || "Bill Number"}</label></Table.HeaderCell>
                                <Table.HeaderCell ><label className="labelName p-bold-600">{titles.billAmount || "Bill Amount"}</label></Table.HeaderCell>
                                <Table.Row>
                                  <Table.HeaderCell colSpan={5} width={5}><label className="labelName p-bold-600">{titles.expenceParticular || "Expense Particular"}</label></Table.HeaderCell>
                                  <Table.HeaderCell colSpan={5} width={5}><label className="labelName p-bold-600" style={{ marginLeft: '70px' }}>{titles.penalityAmount || "Penalty Amount"}</label></Table.HeaderCell>
                                  <Table.HeaderCell colSpan={4} width={4}></Table.HeaderCell>
                                </Table.Row>

                              </Table.Row>
                            </Table.Header>
                            <Table.Body>
                              {billDetails.map((bill, billIndex) => {
                                return (
                                  <>
                                    <Table.Row>
                                      <Table.Cell>
                                        <FormUi.Field>
                                          <Fieldmik name="billReferenceNo" component={MyInput} placeholder="Code" value={bill.billReferenceNo} />
                                          {touched.billReferenceNo && errors.billReferenceNo ? <Label size="mini" prompt pointing>{errors.billReferenceNo}</Label> : ''}
                                        </FormUi.Field>
                                      </Table.Cell>
                                      <Table.Cell>
                                        <FormUi.Field>
                                          <Fieldmik name="billAmount" component={MyInput} placeholder="Bill Amount" value={bill.billAmount} />
                                          {touched.billAmount && errors.billAmount ? <Label size="mini" prompt pointing>{errors.billAmount}</Label> : ''}
                                        </FormUi.Field>
                                      </Table.Cell>

                                      <FieldArray
                                        name={`billDetails[${billIndex}].penaltyList`}
                                      >
                                        {({ push, remove, form }) => {

                                          const { initialValues, values, setFieldValue } = form
                                          const { penaltyList } = values.billDetails[billIndex]


                                          return (
                                            <>
                                              {penaltyList.map((penalty, penaltyIndex) => (
                                                <>
                                                  <Table.Row key={`{bill}+ ${penaltyIndex}`}>
                                                    <Table.Cell width={4}>
                                                      <FormUi.Field>
                                                        <Fieldmik psDescription={`billDetails[${billIndex}].penaltyList[${penaltyIndex}].psDescription`} name={`billDetails[${billIndex}].penaltyList[${penaltyIndex}].psCode`} component={PSLineItemDropdown} placeholder={billDetails[billIndex].penaltyList[penaltyIndex].psCode}   usedPSLineItems={billDetails[0].penaltyList}/>
                                                        <ErrorMessage name={`billDetails[${billIndex}].penaltyList[${penaltyIndex}].psCode`}>{msg => <Label size="mini" basic color="red" pointing>{msg}</Label>}</ErrorMessage>
                                                      </FormUi.Field>
                                                    </Table.Cell>

                                                    <Table.Cell width={2}>
                                                      <FormUi.Field>
                                                        <Fieldmik name={`billDetails[${billIndex}].penaltyList[${penaltyIndex}].penaltyAmt`} style={{ width: '160px' }} component={MyInput} type="number" placeholder="Enter Amount" />
                                                        <ErrorMessage name={`billDetails[${billIndex}].penaltyList[${penaltyIndex}].penaltyAmt`}>{msg => <Label size="mini" basic color="red" pointing>{msg}</Label>}</ErrorMessage>
                                                      </FormUi.Field>
                                                    </Table.Cell>

                                                    <Table.Cell width={2}>
                                                      {penaltyIndex > 0 ?
                                                        <Button onClick={() => remove(penaltyIndex)} type="button" basic size="mini" icon>
                                                          <Icon className="overhere" color="red" name="trash" />
                                                        </Button>
                                                        :
                                                        ''}
                                                    </Table.Cell>
                                                  </Table.Row>

                                                </>
                                              ))}

                                              <Table.Cell>
                                                <Button type="button" onClick={() => push({ psCode: '', penaltyAmt: '' })} size="mini" basic color="blue">
                                                  + Add
                                                </Button>
                                              </Table.Cell>

                                            </>
                                          )
                                        }}
                                      </FieldArray>
                                    </Table.Row>
                                  </>
                                )
                              })}

                            </Table.Body>

                          </Table>
                        </>
                      }
                    </Modal.Content>
                  </>
                )
              }}
            </FieldArray>
            <Modal.Actions>
              {disabledButton ?
                null
                :
                <Button onClick={handleCloseBillApproval} size="mini">Cancel</Button>
              }
              <Button disabled={disabledButton} type="submit" onClick={handleSubmit} size="mini" primary>
                {disabledButton ?
                  <Loader active inline size='tiny' />
                  :
                  'Submit'
                }
              </Button>
            </Modal.Actions>
          </>
        )}
      </Formik>
    </>
  )
}


export default BillApprovalModal
